import type { AdminPageAccessRule } from '../../registry.ts';

/** Хто бачить сторінку `trash`: у перший екран їде лише це (опис і код — у `page.ts`). */
export default {
  group: 'data',
  permission: 'data.manage',
} satisfies AdminPageAccessRule;
